import { render, staticRenderFns } from "./MinifiedCarrousel.vue?vue&type=template&id=59efde7a&scoped=true"
import script from "./MinifiedCarrousel.vue?vue&type=script&lang=js"
export * from "./MinifiedCarrousel.vue?vue&type=script&lang=js"
import style0 from "./MinifiedCarrousel.vue?vue&type=style&index=0&id=59efde7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59efde7a",
  null
  
)

export default component.exports